// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__3FlDl","main":"styles_main__1DDEV","about":"styles_about__2TJa3","text":"styles_text__3_zxn","image":"styles_image__dI2-Z"};